import AppContainer from '../client/pages/appContainer'
import SearchPageContainer from '../client/pages/search/searchPageContainer'
import LandingPageContainer from '../client/pages/landing/landingPageContainer'
import NotFoundPageContainer from '../client/pages/notFoundContainer'

export default [
  {
    path: '/',
    component: AppContainer,
    routes: [
      {
        path: '/',
        exact: true,
        component: SearchPageContainer
      },
      {
        path: '/category/*',
        component: SearchPageContainer
      },
      {
        path: '/tags/:tags',
        component: SearchPageContainer
      },
      {
        path: '/attributes/:key/:value',
        component: SearchPageContainer
      },
      {
        path: '/search',
        component: SearchPageContainer
      },
      {
        path: '/free/:page',
        component: LandingPageContainer
      },
      {
        path: '/*',
        component: NotFoundPageContainer
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./common/routes.js